import React, { FC, useContext, useEffect, useState } from 'react';
import { faCreditCard, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Form from 'react-bootstrap/Form';
import { ButtonStyled } from 'components/UI/styled/button-styled';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import { FormSection, SubmitButton, CancelButton, FormToolbar } from './style';

const FinancialAccountForm: FC<any> = ({ data, onSubmit, onCancel }) => {
  const [validated, setValidated] = useState(false);
  const [formData, setFormData] = useState<any>();

  useEffect(() => {
    setFormData({ ...data });
  }, []);

  const onInputChange = (e, inputName) => {
    const newFormData: any = formData as any;

    if (newFormData) {
      newFormData[inputName] = e.target.value;
      setFormData(newFormData);
    }

  };

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      event.preventDefault();
      event.stopPropagation();
      onSubmit(formData);
    }

    setValidated(true);
  };

  return (
    <>
      <FormSection>
        <FontAwesomeIcon icon={faCreditCard} size="2x" color="#4A90E2" />
        <span>Dados da conta</span>
      </FormSection>

      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <Form.Row>
          <Form.Group as={Col} md="12" controlId="validationCustom01">
            <Form.Control
              required
              type="text"
              placeholder="Banco"
              defaultValue={formData?.banco}
              onChange={(e) => onInputChange(e, 'banco')}
            />
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group as={Col} md="6" controlId="validationCustom02">
            <Form.Control
              required
              type="text"
              placeholder="Agência"
              defaultValue={formData?.agencia}
              onChange={(e) => onInputChange(e, 'agencia')}
            />
          </Form.Group>
          <Form.Group as={Col} md="6" controlId="validationCustom03">
            <Form.Control
              required
              type="text"
              placeholder="Conta corrente"
              defaultValue={formData?.conta}
              onChange={(e) => onInputChange(e, 'conta')}
            />
          </Form.Group>
        </Form.Row>
        <FormSection>
          <FontAwesomeIcon icon={faUser} size="2x" color="#4A90E2" />
          <span>Responsável financeiro</span>
        </FormSection>
        <Form.Row>
          <Form.Group as={Col} md="12" controlId="validationCustom04">
            <Form.Control
              required
              type="text"
              placeholder="Nome"
              defaultValue={formData?.nomeResponsavel}
              onChange={(e) => onInputChange(e, 'nomeResponsavel')}
            />
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group as={Col} md="12" controlId="validationCustom05">
            <Form.Control
              required
              type="text"
              placeholder="Telefone"
              defaultValue={formData?.telefone}
              onChange={(e) => onInputChange(e, 'telefone')}
            />
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group as={Col} md="12" controlId="validationCustom06">
            <Form.Control
              required
              type="email"
              placeholder="E-mail"
              defaultValue={formData?.email}
              onChange={(e) => onInputChange(e, 'email')}
            />
            <Form.Control.Feedback type="invalid">
              Preencha um e-mail válido.
            </Form.Control.Feedback>
          </Form.Group>
        </Form.Row>
        <FormToolbar>
          <CancelButton onClick={onCancel}>Cancelar</CancelButton>
          <SubmitButton type="submit">Salvar</SubmitButton>
        </FormToolbar>
      </Form>
    </>
  );
};

export default FinancialAccountForm;
